import { useState } from "react";
import { useCurrencies } from "@/hooks";
import Loader from "@/components/loader/Loader";
import { MarketView } from "@/components/p2p/MarketView ";
import { useAppSelector } from "@/store/hooks";
import TradeModal from "@/components/p2p/TradeModal";
import { ErrorState } from "@/components/ErrorState";

type ViewMode = "market" | "trade" | "my-trades";

const P2PPage = () => {
  const { theme } = useAppSelector((state) => state.ui);
  const [viewMode, setViewMode] = useState<ViewMode>("market");
  const [showTradeModal, setShowTradeModal] = useState(false);

  const {
    data: currencies,
    isLoading: isLoadingCurrencies,
    isError,
    refetch,
  } = useCurrencies();

  const { side, cryptoCode, amount, selectedAd } = useAppSelector(
    (state) => state.p2pMarket,
  );

  if (isLoadingCurrencies) return <Loader type="bounce" />;

  if (isError) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <div
      className={`min-h-screen ${theme === "dark" ? "bg-background" : "bg-gray-50"}`}
    >
      <div className="max-w-7xl mx-auto p-1 lg:px-6 py-8">
        {viewMode === "market" && <MarketView />}

        {/* Trade Modal */}
        <TradeModal
          showTradeModal={showTradeModal}
          setShowTradeModal={setShowTradeModal}
          side={side}
          crypto={cryptoCode}
          selectedAd={selectedAd}
          amount={amount}
        />
      </div>
    </div>
  );
};

export default P2PPage;
